import { render, staticRenderFns } from "./MessageSent.vue?vue&type=template&id=140c38ee&scoped=true&"
import script from "./MessageSent.vue?vue&type=script&lang=js&"
export * from "./MessageSent.vue?vue&type=script&lang=js&"
import style0 from "./MessageSent.vue?vue&type=style&index=0&id=140c38ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c38ee",
  null
  
)

export default component.exports